import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useAlertStore } from "../store/alertStore";
import { MATCH_ALL } from "./routePaths";
import { useMetrics } from "../helpers/metrics";
import bldgCodeGuard from "./bldgCodeGuard";
import authGuard from "./authGuard";
import staffGuard from "./staffGuard";

//import NoBuilding from "../views/NoBuilding.vue"
import Home from "../views/Home.vue";
import Contacts from "../views/Contacts.vue";
import Resources from "../views/Resources.vue";
import VRTraining from "../views/VRTraining.vue";
import Training from "../views/Training.vue";
import Video from "../views/Video.vue";
import Question from "../views/Question.vue";
import Result from "../views/Result.vue";
import TrainingFinish from "../views/TrainingFinish.vue";
import Response from "../views/Response.vue";
import NotFound from "../views/NotFound.vue";
import Privacy from "../views/Privacy.vue";
import Terms from "../views/Terms.vue";
import Help from "../views/Help.vue";
import AlertHelp from "../views/AlertHelp.vue";
import Unsubscribe from "../views/Unsubscribe.vue";
import UnsubscribeTraining from "../views/UnsubscribeTraining.vue";
import Token from "../views/Token.vue";
import StartTour from "../views/StartTour.vue";
import VRErrorMessage from "../views/VRErrorMessage.vue";

import AdminHome from "../views/admin/AdminHome.vue";
import AdminUsers from "../views/admin/AdminUsers.vue";
import AdminTests from "../views/admin/AdminTests.vue";
// import AdminReports from "../views/admin/AdminReports.vue";
import AdminAlert from "../views/admin/AdminAlert.vue";
import AdminMultiAlert from "../views/admin/AdminMultiAlert.vue";

import AdminAlertTemplates from "../views/admin/AdminAlertTemplates.vue";
import AdminAlertHistory from "../views/admin/AdminAlertHistory.vue";
import AdminRespond from "../views/admin/AdminRespond.vue";
import AdminTenants from "../views/admin/AdminTenants.vue";

import AdminTrainingReport from "../views/admin/AdminTrainingReport.vue";
import AdminRosterReport from "../views/admin/AdminRosterReport.vue";
import AdminMobilityReport from "../views/admin/AdminMobilityReport.vue";
import AdminVrReport from "../views/admin/AdminVRReport.vue";
import AdminVRFilterReport from "../views/admin/AdminVRFilterReport.vue";
import AdminTenantContactReport from "../views/admin/AdminTenantContactReport.vue";
import AdminDocuments from "../views/admin/AdminDocuments.vue";
import AdminNumbers from "../views/admin/AdminNumbers.vue";

import AdminAlertSubscriptions from "../views/admin/AdminAlertSubscriptions.vue";

import StaffDashboard from "../views/staffadmin/Dashboard.vue";
import StaffLogin from "../views/staffadmin/StaffLogin.vue";
import StaffForgotPassword from "../views/staffadmin/StaffForgotPassword.vue";
import StaffResetPassword from "../views/staffadmin/StaffResetPassword.vue";

//Safetynet
import Portals from "../views/staffadmin/Portal.vue";
import InviteCodes from "../views/staffadmin/InviteCodes.vue";
import Tenants from "../views/staffadmin/Tenants.vue";
import Users from "../views/staffadmin/Users.vue";
import User from "../views/staffadmin/User.vue";
import PortalMetrics from "../views/staffadmin/PortalMetrics.vue";
import ClientMetrics from "../views/staffadmin/ClientMetrics.vue";

import Documents from "../views/staffadmin/Documents.vue";
import Numbers from "../views/staffadmin/Numbers.vue";
import Links from "../views/staffadmin/Links.vue";
import LinksSearch from "../views/staffadmin/LinksSearch.vue";
import LinkWarnings from "../views/staffadmin/LinkWarnings.vue";
import Customization from "../views/staffadmin/Customization.vue";
import Respond from "../views/staffadmin/Respond.vue";
import Roles from "../views/staffadmin/Roles.vue";
import UserCollections from "../views/staffadmin/UserCollections.vue";
import Prepare from "../views/staffadmin/Prepare.vue";
import StaffAdminTrainingProgram from "../views/staffadmin/TrainingProgram.vue";
import StaffAdminTrainingModule from "../views/staffadmin/TrainingModule.vue";
import StaffAdminTest from "../views/staffadmin/Test.vue";
import StaffAdminQuestion from "../views/staffadmin/Question.vue";

import Reports from "../views/staffadmin/Reports.vue";
import TrainingReport from "../views/staffadmin/TrainingReport.vue";
import WardenReport from "../views/staffadmin/RosterReport.vue";
import TenantContactReport from "../views/staffadmin/TenantContactReport.vue";
import MobilityReport from "../views/staffadmin/MobilityReport.vue";
import VrReport from "../views/staffadmin/VRReport.vue";
import VrFilterReport from "../views/staffadmin/VRFilterReport.vue";
import TrainingExpirationReport from "../views/staffadmin/TrainingExpirationReport.vue";

import StaffProfile from "../views/staffadmin/Profile.vue";

import StaffSendAlert from "../views/staffadmin/SendAlert.vue";
import StaffSendMultiAlert from "../views/staffadmin/SendMultiAlert.vue";
import StaffAlertSubscriptions from "../views/staffadmin/AlertSubscriptions.vue";
import StaffTemplates from "../views/staffadmin/AlertTemplates.vue";
import StaffAlertHistoryAll from "../views/staffadmin/AlertHistoryAll.vue";

import StaffClientAdminHelp from "../views/staffadmin/AdminHelp.vue";

//Global Lists
import StaffVideos from "../views/staffadmin/Videos.vue";
import StaffVideo from "../views/staffadmin/Video.vue";
import RespondLibs from "../views/staffadmin/RespondLibraries.vue";
import RespondLib from "../views/staffadmin/RespondLibrary.vue";
import RespondScenarios from "../views/staffadmin/RespondScenarios.vue";
import RespondSearchResults from "../views/staffadmin/RespondSearchResults.vue";

import RolesList from "../views/staffadmin/RolesList.vue";
import ContentLib from "../views/staffadmin/ContentLibrary.vue";
import EmailLib from "../views/staffadmin/EmailLib.vue";

import Clients from "../views/staffadmin/Clients.vue";
import Client from "../views/staffadmin/Client.vue";

import AlertHistoryDetail from "../views/staffadmin/AlertHistoryDetail.vue";
import BouncedEmails from "../views/staffadmin/BouncedEmails.vue";

// Staff Admin - Administration
import Overview from "../views/staffadmin/Overview.vue";
import StaffNotifications from "../views/staffadmin/Notifications.vue";
import Helpers from "../views/staffadmin/Helpers.vue";
import BulkEdit from "../views/staffadmin/BulkEdit.vue";
import Metrics from "../views/staffadmin/Metrics.vue";

import MsalPlayground from "../views/MsalPlayground.vue";

// import AdminSidebarMenuMain from "@/views/admin/common/sidebar-menu-main.vue";
// import AdminSidebarMenuSystem from "@/views/admin/common/sidebar-menu-system.vue";

// import Space from "@/views/space/index.vue";

import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import RootLogin from "../views/RootLogin.vue";
import Register from "../views/Register.vue";
import ExternalRegister from "../views/ExternalRegister.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ConfirmEmail from "../views/ConfirmEmail.vue";
import UnconfirmedEmail from "../views/UnconfirmedEmail.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import SetPersonalPassword from "../views/SetPersonalPassword.vue";
import SsoChosePortal from "../views/SsoChosePortal.vue";
import PortalList from "../views/PortalList.vue";
import StaffSSO from "../views/staffadmin/StaffSSO.vue";

import Account from "../views/Account.vue";

// import Logout from "@/views/logout.vue";
// import Forgot from "@/views/forgot.vue";
// import Profile from "@/views/Profile.vue";

const routes: Array<RouteRecordRaw> = [
  // { name: "select-building", path: "/", component: NoBuilding },

  //Root Login page
  { name: "root-login", path: "/", redirect: "/login" },
  { name: "global-login", path: "/login", component: RootLogin },
  { name: "client-password", path: "/forgotpassword", component: ForgotPassword },
  {
    name: "client-resetpassword",
    path: "/client/resetpassword",
    component: ResetPassword,
  },
  { name: "privacy-content", path: "/content/privacy", component: Privacy },
  { name: "privacy-content", path: "/content/terms", component: Terms },
  { name: "client-login", path: "/client/:clientsystemname", component: RootLogin },
  { name: "client-register", path: "/client/:clientsystemname/register", component: Register },
  { name: "region-login", path: "/client/:clientsystemname/:regionname", component: RootLogin },

  // Client Admin

  //TODO: worry about how to do multi-building Admin logins later...

  // { name: "admin-home", path: "/admin", component: AdminHome, beforeEnter: authGuard },

  // { name: "admin-users", path: "/admin/users", component: AdminUsers, beforeEnter: authGuard },
  // { name: "admin-tests", path: "/admin/tests", component: AdminTests, beforeEnter: authGuard },
  // { name: "admin-reports", path: "/admin/reports", component: AdminReports, beforeEnter: authGuard },
  // { name: "admin-roles", path: "/admin/roles", component: AdminAlert, beforeEnter: authGuard },

  // { name: "admin-training-report", path: "/admin/trainingreport", component: AdminTrainingReport },
  // { name: "admin-warden-report", path: "/admin/wardenreport", component: AdminWardenReport },
  // { name: "admin-mobility-report", path: "/admin/mobilityreport", component: AdminMobilityReport },
  // { name: "admin-vr-report", path: "/admin/vrreport", component: AdminVrReport },

  //SsoChosePortal
  { name: "sso-choose-portal", path: "/ssochooseportal", component: SsoChosePortal },
  { name: "portal-list-client", path: "/portallist/:clientsystemname", component: PortalList },
  {
    name: "portal-list-region",
    path: "/portallist/:clientsystemname/:regionname",
    component: PortalList,
  },

  { name: "staff-sso", path: "/staff/token", component: StaffSSO },

  // Staff Dashboard
  { name: "staff-dashboard", path: "/staff", component: StaffDashboard, beforeEnter: staffGuard },
  { name: "staff-login", path: "/staff/login", component: StaffLogin },
  { name: "staff-forgot-password", path: "/staff/forgotpassword", component: StaffForgotPassword },
  { name: "staff-reset-password", path: "/staff/resetpassword", component: StaffResetPassword },

  // Staff Admin - Global Lists  */
  { name: "staff-videos", path: "/staff/videos", component: StaffVideos, beforeEnter: staffGuard },
  {
    name: "staff-video",
    path: "/staff/video/:videoId",
    component: StaffVideo,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-respond-libs",
    path: "/staff/respondlibraries",
    component: RespondLibs,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-respond-lib",
    path: "/staff/respondlibrary/:libId",
    component: RespondLib,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-respond-types",
    path: "/staff/respondscenarios",
    component: RespondScenarios,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-respond-search-results",
    path: "/staff/respondsearchresults",
    component: RespondSearchResults,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-roles-list",
    path: "/staff/roleslist",
    component: RolesList,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-content-lib",
    path: "/staff/content",
    component: ContentLib,
    beforeEnter: staffGuard,
  },
  { name: "staff-email-lib", path: "/staff/email", component: EmailLib, beforeEnter: staffGuard },
  { name: "staff-clients", path: "/staff/clients", component: Clients, beforeEnter: staffGuard },
  {
    name: "staff-client",
    path: "/staff/client/:clientId",
    component: Client,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-alert-history-detail",
    path: "/staff/alert/detail/:alertHistoryId",
    component: AlertHistoryDetail,
    beforeEnter: staffGuard,
  },

  {
    name: "staff-bounced-emails",
    path: "/staff/bouncedemails",
    component: BouncedEmails,
    beforeEnter: staffGuard,
  },

  // Staff Admin - Administration
  { name: "staff-overview", path: "/staff/overview", component: Overview, beforeEnter: staffGuard },
  { name: "staff-helpers", path: "/staff/helpers", component: Helpers, beforeEnter: staffGuard },
  { name: "staff-bulkedit", path: "/staff/bulkedit", component: BulkEdit, beforeEnter: staffGuard },
  { name: "staff-metrics", path: "/staff/metrics", component: Metrics, beforeEnter: staffGuard },

  // Staff Admin - Safetynet Portals
  {
    name: "staff-portals",
    path: "/staff/:sitecode/portal",
    component: Portals,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-numbers",
    path: "/staff/:sitecode/numbers",
    component: Numbers,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-respond",
    path: "/staff/:sitecode/respond",
    component: Respond,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-roles",
    path: "/staff/:sitecode/roles",
    component: Roles,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-user-collections",
    path: "/staff/:sitecode/usercollections",
    component: UserCollections,
    beforeEnter: staffGuard,
  },

  {
    name: "staff-reports",
    path: "/staff/:sitecode/reports",
    component: Reports,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-training-report",
    path: "/staff/:sitecode/reports/trainingreport",
    component: TrainingReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-property-roster-report",
    path: "/staff/:sitecode/reports/propertyrosterreport",
    component: WardenReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-tenant-contact-report",
    path: "/staff/:sitecode/reports/tenantcontactreport",
    component: TenantContactReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-mobility-report",
    path: "/staff/:sitecode/reports/mobilityreport",
    component: MobilityReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-vr-report",
    path: "/staff/:sitecode/reports/vrreport",
    component: VrReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-vr-filter-report",
    path: "/staff/:sitecode/reports/vrfilterreport",
    component: VrFilterReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-training-expiration-report",
    path: "/staff/:sitecode/reports/trainingexpirationreport",
    component: TrainingExpirationReport,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-profile",
    path: "/staff/profile",
    component: StaffProfile,
    beforeEnter: staffGuard,
  },

  {
    name: "staff-customization",
    path: "/staff/:sitecode/customization",
    component: Customization,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-documents",
    path: "/staff/:sitecode/documents",
    component: Documents,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-invitecodes",
    path: "/staff/:sitecode/invitecodes",
    component: InviteCodes,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-links",
    path: "/staff/:sitecode/links",
    component: Links,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-links-search",
    path: "/staff/linksearch",
    component: LinksSearch,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-link-warnings",
    path: "/staff/linkwarnings",
    component: LinkWarnings,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-tenants",
    path: "/staff/:sitecode/tenants",
    component: Tenants,
    beforeEnter: staffGuard,
  },

  {
    name: "staff-users",
    path: "/staff/:sitecode/users",
    component: Users,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-user",
    path: "/staff/:sitecode/user/:personId",
    component: User,
    beforeEnter: staffGuard,
  },

  {
    name: "staff-prepare",
    path: "/staff/:sitecode/prepare",
    component: Prepare,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-trainingprogram",
    path: "/staff/:sitecode/prepare/trainingprogram/:trainingProgramId",
    component: StaffAdminTrainingProgram,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-trainingmodule",
    path: "/staff/:sitecode/prepare/trainingmodule/:trainingModuleId",
    component: StaffAdminTrainingModule,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-test",
    path: "/staff/:sitecode/prepare/test/:testId",
    component: StaffAdminTest,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-question",
    path: "/staff/:sitecode/prepare/question/:questionId",
    component: StaffAdminQuestion,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-send-alert",
    path: "/staff/:sitecode/alert",
    component: StaffSendAlert,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-send-multi-alert",
    path: "/staff/:sitecode/multialert",
    component: StaffSendMultiAlert,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-alert-subscriptions",
    path: "/staff/:sitecode/alert/subscriptions",
    component: StaffAlertSubscriptions,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-templates",
    path: "/staff/:sitecode/alert/templates",
    component: StaffTemplates,
    beforeEnter: staffGuard,
  },
  {
    // Old per-building staff history page, superseded by the all-portals history
    path: "/staff/:sitecode/alert/history",
    redirect: "/staff/alert/history/all",
  },
  {
    name: "staff-alert-history-all",
    path: "/staff/alert/history/all",
    component: StaffAlertHistoryAll,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-notifications",
    path: "/staff/notifications",
    component: StaffNotifications,
    beforeEnter: staffGuard,
  },
  {
    name: "admin-help",
    path: "/staff/adminhelp",
    component: StaffClientAdminHelp,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-portal-metrics",
    path: "/staff/:sitecode/portalmetrics",
    component: PortalMetrics,
    beforeEnter: staffGuard,
  },
  {
    name: "staff-client-metrics",
    path: "/staff/:sitecode/clientmetrics",
    component: ClientMetrics,
    beforeEnter: staffGuard,
  },

  {
    name: "admin-portal-home",
    path: "/:sitecode/admin",
    component: AdminHome,
    beforeEnter: authGuard,
  },
  {
    name: "admin-users",
    path: "/:sitecode/admin/users",
    component: AdminUsers,
    beforeEnter: authGuard,
  },
  {
    name: "admin-tests",
    path: "/:sitecode/admin/tests",
    component: AdminTests,
    beforeEnter: authGuard,
  },
  // Reports list now on Client admin homepage
  // {
  //   name: "admin-reports",
  //   path: "/:sitecode/admin/reports",
  //   component: AdminReports,
  //   beforeEnter: authGuard,
  // },
  {
    name: "admin-alert",
    path: "/:sitecode/admin/alert",
    component: AdminAlert,
    beforeEnter: authGuard,
  },
  {
    name: "admin-multi-alert",
    path: "/:sitecode/admin/multialert",
    component: AdminMultiAlert,
    beforeEnter: authGuard,
  },
  {
    name: "admin-alert-templates",
    path: "/:sitecode/admin/alert/templates",
    component: AdminAlertTemplates,
    beforeEnter: authGuard,
  },

  {
    name: "admin-alert-history",
    path: "/:sitecode/admin/alert/history",
    component: AdminAlertHistory,
    beforeEnter: authGuard,
  },

  {
    name: "admin-training-report",
    path: "/:sitecode/admin/trainingreport",
    component: AdminTrainingReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-property-roster-report",
    path: "/:sitecode/admin/propertyrosterreport",
    component: AdminRosterReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-mobility-report",
    path: "/:sitecode/admin/mobilityreport",
    component: AdminMobilityReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-vr-report",
    path: "/:sitecode/admin/vrreport",
    component: AdminVrReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-vr-filter-report",
    path: "/:sitecode/admin/vrfilterreport",
    component: AdminVRFilterReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-tenant-contact-report",
    path: "/:sitecode/admin/tenantcontactreport",
    component: AdminTenantContactReport,
    beforeEnter: authGuard,
  },
  {
    name: "admin-docs",
    path: "/:sitecode/admin/docs",
    component: AdminDocuments,
    beforeEnter: authGuard,
  },
  {
    name: "admin-contacts",
    path: "/:sitecode/admin/contacts",
    component: AdminNumbers,
    beforeEnter: authGuard,
  },

  {
    name: "admin-alert-subscriptions",
    path: "/:sitecode/admin/alert/subscriptions",
    component: AdminAlertSubscriptions,
    beforeEnter: authGuard,
  },

  {
    name: "admin-respond-editor",
    path: "/:sitecode/admin/respond",
    component: AdminRespond,
    beforeEnter: authGuard,
  },
  {
    name: "admin-tenants-editor",
    path: "/:sitecode/admin/tenants",
    component: AdminTenants,
    beforeEnter: authGuard,
  },

  // Staff Dashboard
  { name: "staff-dashboard", path: "/staff", component: StaffDashboard, beforeEnter: staffGuard },
  { name: "staff-login", path: "/staff/login", component: StaffLogin },

  {
    name: "bldg-root",
    path: "/:sitecode",
    component: Home,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "terms",
    path: "/:sitecode/terms",
    component: Terms,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "privacy",
    path: "/:sitecode/privacy",
    component: Privacy,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "help",
    path: "/:sitecode/help",
    component: Help,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "alert-help",
    path: "/:sitecode/alerthelp",
    component: AlertHelp,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "unsubscribe",
    path: "/:sitecode/unsubscribe",
    component: Unsubscribe,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "unsubscribe-training",
    path: "/:sitecode/unsubscribetraining",
    component: UnsubscribeTraining,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "vrerrormessage",
    path: "/:sitecode/vrerrormessage",
    component: VRErrorMessage,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "vrerrormessage-404",
    path: "/vr/:sitecode/:path*",
    component: VRErrorMessage,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "contacts",
    path: "/:sitecode/contacts",
    component: Contacts,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "resources",
    path: "/:sitecode/resources",
    component: Resources,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "vrtraining",
    path: "/:sitecode/vrtraining",
    component: VRTraining,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "login",
    path: "/:sitecode/login",
    component: Login,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "logout",
    path: "/:sitecode/logout",
    component: Logout,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "register",
    path: "/:sitecode/register",
    component: Register,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "externalregister",
    path: "/:sitecode/externalregister",
    component: ExternalRegister,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "forgotpassword",
    path: "/:sitecode/forgotpassword",
    component: ForgotPassword,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "resetpassword",
    path: "/:sitecode/resetpassword",
    component: ResetPassword,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "confirmEmail",
    path: "/:sitecode/confirmemail",
    component: ConfirmEmail,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "UnconfirmedEmail",
    path: "/:sitecode/unconfirmedemail",
    component: UnconfirmedEmail,
    beforeEnter: bldgCodeGuard,
  },
  //SetPersonalPassword
  {
    name: "setpassword",
    path: "/:sitecode/setpassword",
    component: SetPersonalPassword,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "account",
    path: "/:sitecode/account",
    component: Account,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "training",
    path: "/:sitecode/training",
    component: Training,
    beforeEnter: authGuard,
  },
  {
    name: "video",
    path: "/:sitecode/training/module/:moduleId/video",
    component: Video,
    beforeEnter: authGuard,
  },
  {
    name: "question",
    path: "/:sitecode/training/module/:moduleId/question/:questionNumber",
    component: Question,
    beforeEnter: authGuard,
  },
  {
    name: "result",
    path: "/:sitecode/training/module/:moduleId/question/:questionNumber/result",
    component: Result,
    beforeEnter: authGuard,
  },
  {
    name: "trainingfinish",
    path: "/:sitecode/training/:programId/finish",
    component: TrainingFinish,
    beforeEnter: authGuard,
  },
  {
    name: "login-token",
    path: "/:sitecode/token",
    component: Token,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "starttour",
    path: "/:sitecode/starttour",
    component: StartTour,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "response",
    path: "/:sitecode/response/:responseSysName",
    component: Response,
    beforeEnter: bldgCodeGuard,
  },
  {
    name: "authplayground",
    path: "/authplayground",
    component: MsalPlayground,
  },
  {
    name: "NotFound",
    path: MATCH_ALL,
    component: NotFound,
  },

  //   {
  //     name: "select-building",
  //     path: "/",
  //     component: NoBuilding,
  //   },
  //   {
  //     ...RouteMap.ADMIN,
  //     components: {
  //       SidebarMenu: AdminSidebarMenuMain,
  //       default: () => import("../views/admin/main-views/dashboard.vue"),
  //     },
  //   },
  //   {
  //     name: "bldg-root",
  //     path: "/:bldgCode",
  //     component: Home,
  //     beforeEnter: bldgCodeGuard,
  //   },
  //   {
  //     name: "login",
  //     path: "/:bldgCode/login",
  //     component: Login,
  //     beforeEnter: bldgCodeGuard,
  //   },
  //   {
  //     name: "register",
  //     path: "/:bldgCode/register",
  //     component: Register,
  //     beforeEnter: bldgCodeGuard,
  //   },
  //   {
  //     name: "logout",
  //     path: "/:bldgCode/logout",
  //     component: Logout,
  //     beforeEnter: bldgCodeGuard,
  //   },
  //   {
  //     name: "profile",
  //     path: "/:bldgCode/profile",
  //     component: Profile,
  //     beforeEnter: bldgCodeGuard,
  //   },

  //   {
  //     ...RouteMap.REGISTER,
  //     component: Register,
  //   },
  //   {
  //     ...RouteMap.FORGOT,
  //     component: Forgot,
  //   },
  //   {
  //     ...RouteMap.ADMIN,
  //     component: Admin,
  //     redirect: RoutePath.ADMIN_DASHBOARD,
  //     children: [
  //       // # main views
  //       {
  //         ...RouteMap.ADMIN_DASHBOARD,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuMain,
  //           default: () => import("../views/admin/main-views/dashboard.vue"),
  //         },
  //       },
  //       {
  //         ...RouteMap.ADMIN_CRUD_DEMO,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuMain,
  //           default: () => import("../views/admin/main-views/crud-demo.vue"),
  //         },
  //       },
  //       {
  //         ...RouteMap.ADMIN_INVITE_CODES,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuMain,
  //           default: () => import("../views/admin/main-views/invite-codes.vue"),
  //         },
  //       },
  //       {
  //         ...RouteMap.ADMIN_DOC_PERMISSIONS,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuMain,
  //           default: () => import("../views/admin/main-views/doc-permissions.vue"),
  //         },
  //       },

  //       // # system views
  //       {
  //         ...RouteMap.ADMIN_PROFILE,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuSystem,
  //           default: () => import("../views/admin/system-views/profile.vue"),
  //         },
  //       },
  //       {
  //         ...RouteMap.ADMIN_NOTIFICATIONS,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuSystem,
  //           default: () => import("../views/admin/system-views/notifications.vue"),
  //         },
  //       },
  //       {
  //         ...RouteMap.ADMIN_NOTIFICATION_DETAIL,
  //         components: {
  //           SidebarMenu: AdminSidebarMenuSystem,
  //           default: () => import("../views/admin/system-views/notification-detail.vue"),
  //         },
  //       },

  //       // # common views
  //       {
  //         path: MATCH_ALL,
  //         component: () => import("../views/admin/common/not-found.vue"),
  //       },
  //     ],
  //   },
  //   {
  //     ...RouteMap.SPACE,
  //     component: Space,
  //     redirect: RoutePath.SPACE_HOME,
  //     children: [
  //       // # main views
  //       {
  //         ...RouteMap.SPACE_HOME,
  //         component: () => import("../views/space/home.vue"),
  //       },

  //       // # common views
  //       {
  //         path: MATCH_ALL,
  //         component: () => import("../views/space/common/not-found.vue"),
  //       },
  //     ],
  //   },
  // {
  //   name: 'bldg-root',
  //   path: '/:_(.*)',
  //   component: Home,
  //   children: [
  //     {
  //       name: 'bldg-login',
  //       path: 'login',
  //       component: Login,
  //     },
  //   ],
  // },
];

const metrics = useMetrics();

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === "staff-alert-history-all" && useAlertStore().allHistoriesUiState) {
      return false;
    }
    return { top: 0 };
  },
});

router.beforeEach((to, from) => {
  //console.log("Router beforeEach: ", to, from);
});

router.beforeResolve(async (to) => {
  //console.log("Router beforeResolve", to);
});

router.afterEach((to, from, failure) => {
  if (failure) {
    console.warn("Route Navigation failure", failure);
  } else {
    //console.log("Router after", to, from);
  }
  metrics.pageView();
});

export default router;
